(function() {
  'use strict';
  angular.module('common')
  .filter('maskEmail', function() {
    return function(email) {
      if (email){
        let matches = email.match(/(.?)(.*)(.@.)(.*)(\..*)/);
        if (matches){
            for(let index=0; index < matches.length; index++){
              if (index%2===0){
                matches[index] =  matches[index].replace(/./g,'*');
              }
            }
            return (matches.slice(1).join(""));
        }
      }
    };
  });
})();
